import { MainLayout } from 'layouts'
import { LkmProductTypesList } from './components/LkmProductTypesList/LkmProductTypesList'

export function LkmProductTypesPage() {
  return (
    <MainLayout>
      <div className='container'>
        <h1>Типы изделий</h1>
        <LkmProductTypesList />
      </div>
    </MainLayout>
  )
}
